import { HasOnComplete, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

export interface SurFinancialTransactionsModel {
    searchparameter: StoreParameter;
    financialData: any;
    uri: any;
    currentData: string;
    pastDue: PastDue;
    total: string;
    financialTransactions: FinancialTransaction[];
    pagination: FinancialTransactionsPagination;
    properties: Properties2;
}

export interface PastDue {
    days30: string;
    days45: string;
    days60: string;
    days90: string;
}

export interface FinancialTransaction {
    uri: any;
    invoiceNumber: string;
    orderNumber: string;
    poNumber: string;
    transDate: string;
    transType: string;
    amount: string;
    amountDisplay:string;
    checkNo: string;
    properties: Properties;
}

export interface Properties {}

export interface StoreParameter {
    poNumber?: string;
    invoiceNumber?: string;
    beginDate?: string;
    endDate?: string;
    page?: number;
    pageSize?: number;
    sort?: string;
}

export interface FinancialTransactionsPagination {
    currentPage: number;
    page: number;
    pageSize: number;
    defaultPageSize: number;
    totalItemCount: number;
    numberOfPages: number;
    pageSizeOptions: number[];
    sortOptions: SortOption[];
    sortType: string;
    nextPageUri: any;
    prevPageUri: any;
}

export interface SortOption {
    displayName: string;
    sortType: string;
}

export interface Properties2 {}

export interface FinancialTransactionsParameter extends ApiParameter {
    poNumber?: string;
    invoiceNumber?: string;
    beginDate?: string;
    endDate?: string;
    page?: number;
    pageSize?: number;
    sort?: string;
}

const FinancialTransactionUrl = "api/v2/financialtransactions";

export async function getFinancialTransactions(parameter: FinancialTransactionsParameter) {
    const response = await get<SurFinancialTransactionsModel>(FinancialTransactionUrl, parameter);

    return response;
}
